import AMapLoader from "@amap/amap-jsapi-loader";

window._AMapSecurityConfig = {
    serviceHost: "https://apps.ivyonline.cn/_AMapService",
};

function loadAMap() {
    return AMapLoader.load({
        key: "efcaa3c111f95e389f4a672974e7a2ce", 
        version: "2.0",
        plugins: ["AMap.Geocoder", "AMap.ToolBar", "AMap.Geolocation", "AMap.Driving", "AMap.AutoComplete","AMap.CitySearch"],
    });
}

export { loadAMap };